export const deliveryTypes = [
    {
        label: 'Entrega',
        value: 'EN',
    },
    {
        label: 'Consumir no Local',
        value: 'LOCAL',
    },
    {
        label: 'Retirar no Local',
        value: 'RE',
    },
    {
        label: 'Agendamento para Entrega',
        value: 'AG',
    },
    {
        label: 'Agendamento para retirada',
        value: 'AGRE',
    },
];